export const permissions = {
  VIEW_DASHBOARD: "view_dashboard",
  VIEW_PROFESSIONALS: "view_professionals",
  VIEW_PROFESSIONAL_SERVICE: "view_professional_service",
  VIEW_HANDYMAN: "view_handyman",
  VIEW_HANDYMAN_SERVICE: "view_handyman_service",
  VIEW_VENDOR: "view_vendor",
  VIEW_PORTFOLIO: "view_portfolio",
  VIEW_ESTATE: "view_estate",
  VIEW_REALTOR: "view_realtor",
  VIEW_ESTATE_FEATURE_CATEGORY: "view_estate_feature_category",
  VIEW_ESTATE_PROPERTY_TYPE: "view_estate_property_type",
  VIEW_PRODUCT: "view_product",
  VIEW_PRODUCT_TAG: "view_product_tag",
  VIEW_PRODUCT_CATEGORY: "view_product_category",
  VIEW_PRODUCT_ATTRIBUTE: "view_product_attribute",
  VIEW_ORDER: "view_order",
  VIEW_TRANSACTION: "view_transaction",
  VIEW_BUYER: "view_buyer",
  VIEW_ORDER_PAYOUT: "view_order_payout",
  VIEW_USER: "view_user",
  VIEW_ROLE: "view_role",
  VIEW_USER_LOGIN_LOCATION: "view_user_login_location",
  VIEW_OFFERS: "view_offers",
  VIEW_BUYERS: "view_buyers",
  VIEW_AFFILIATE: "view_affiliate",
  VIEW_AFFILIATE_SALES: "view_affiliate_sales",
  VIEW_AFFILIATE_PAYOUTS: "view_affiliate_payouts",
  VIEW_POINTS: "view_points",
  VIEW_POINT_ORDERS: "view_point_orders",
  VIEW_FAQ: "view_faq",
  VIEW_PROMOTIONS: "view_promotions",
  VIEW_ADVERTISEMENT: "view_advertisement",
  VIEW_COMMISSION: "view_commission",
  VIEW_TESTIMONIAL: "view_testimonial",
  VIEW_PAGE_CONTENT: "view_page_content",
  ALL: "all",
  CRUD: "crud",
  APPROVE_PRODUCT: "approve_product",
  DELETE_PRODUCT: "delete_product",
  PROMOTE_PRODUCT: "promote_product",
  EDIT_PRODUCT: "edit_product",

  DELETE_ESTATE: "delete_estate",
  APPROVE_ESTATE: "approve_estate",
  PROMOTE_ESTATE: "promote_estate",
  EDIT_ESTATE: "edit_estate",

  DELETE_HANDYMAN: "delete_handyman",
  APPROVE_HANDYMAN: "approve_handyman",
  PROMOTE_HANDYMAN: "promote_handyman",
  EDIT_HANDYMAN: "edit_handyman",
  VIEW_HANDYMAN_SERVICE: "view_handyman_service",

  DELETE_PROFESSIONAL: "delete_professional",
  APPROVE_PROFESSIONAL: "approve_professional",
  PROMOTE_PROFESSIONAL: "promote_professional",
  EDIT_PROFESSIONAL: "edit_professional",
  VIEW_PROFESSIONAL_SERVICE: "view_professional_service",

  DELETE_REALTOR: "delete_realtor",
  APPROVE_REALTOR: "approve_realtor",
};
